module.exports = __webpack_public_path__ + "img/IMG_20200821_175701.a6ae15a7.a6ae15a7.jpg";